module.exports = __webpack_public_path__ + "img/search.b7c5cf0e.svg";